module.exports = __webpack_public_path__ + "img/stan.546862b7.png";